import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/special-pricing-requests';

const specialPricingRequestsService = {
  async list(params = {}) {
    const response = await apiClient.get(BASE, { params });
    return response?.data;
  },

  async get(uuid) {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    return response?.data;
  },

  async create(body) {
    const response = await apiClient.post(BASE, body);
    return response?.data;
  },

  async approve(uuid) {
    const response = await apiClient.post(`${BASE}/${uuid}/approve`);
    return response?.data;
  },

  async reject(uuid, body) {
    const response = await apiClient.post(`${BASE}/${uuid}/reject`, body);
    return response?.data;
  },

  async cancel(uuid) {
    const response = await apiClient.post(`${BASE}/${uuid}/cancel`);
    return response?.data;
  },
};

export default specialPricingRequestsService;
